import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FormFieldControl } from "src/app/common/components/form/form-field-control";

export interface SelectFieldOption {
  value: string;
  label: string;
}

@Component({
  selector: "app-select-field",
  templateUrl: "./select-field.component.html",
  styleUrls: ["./select-field.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, ReactiveFormsModule]
})
export class SelectFieldComponent extends FormFieldControl {
  @Input() options: Array<SelectFieldOption> = [];
  @Input() name: string | null = null;

  trackByValue(_: number, option: SelectFieldOption): string {
    return option.value;
  }
}
